"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateNameLegalChange = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var react_redux_1 = require("react-redux");
var ajax_util_1 = require("../../../utils/ajax/ajax.util");
var constants_1 = require("../../../constants");
var pp_react_1 = require("@paypalcorp/pp-react");
var ROUTES = constants_1.default.ROUTES, VIEWS = constants_1.default.VIEWS;
var name_1 = require("../../../actions/name");
var name_2 = require("../../../utils/name");
var commonweb_utils_1 = require("commonweb-utils");
var interpolate_component_1 = require("../../../components/interpolate-component");
var page = require("page");
var UpdateNameLegalChange = /** @class */ (function (_super) {
    tslib_1.__extends(UpdateNameLegalChange, _super);
    function UpdateNameLegalChange(props) {
        var _this = _super.call(this, props) || this;
        _this.files = [];
        _this.uploadAction = function () {
            _this.inputReference.current.click();
        };
        _this.uploadHandler = function (event) {
            var self = _this;
            event.preventDefault();
            var file = event.target.files[0];
            var filesLocal = self.files;
            var fileValidity = name_2.checkFileValidity(file, _this.nameContent);
            if (!fileValidity.isValid) {
                self.setState({ errorMessage: fileValidity.errorMessage });
            }
            if (file && fileValidity.isValid) {
                self.setState({ errorMessage: "" });
                var reader_1 = new FileReader();
                reader_1.readAsDataURL(file);
                reader_1.addEventListener("load", function () {
                    var result = reader_1.result;
                    if (result != null) {
                        var base64result = reader_1.result.split(",")[1];
                        var formattedSize = name_2.formatBytes(file.size, 2);
                        var fileObj = new File(file.name, base64result, formattedSize);
                        filesLocal.push(fileObj);
                        self.setState({ files: filesLocal });
                    }
                });
                reader_1.onerror = function (error) {
                    self.setState({
                        errorMessage: self.props.content.common.genericServerError,
                    });
                };
                event.currentTarget.value = "";
                window.scrollTo(0, document.body.scrollHeight);
            }
        };
        _this.removeFile = function (key, event) {
            event.preventDefault();
            if (_this.state.showSpinner != true) {
                var filesLocal = _this.state.files;
                filesLocal.splice(--key, 1);
                _this.setState({ files: filesLocal });
            }
        };
        _this.inputChangedHandler = function (event) {
            var isChecked = event.target.checked;
            _this.setState({
                consent: isChecked,
            });
            _this.setState({ errorMessage: "" });
        };
        _this.submitHandler = function (event) {
            event.preventDefault();
            var formData = {};
            if (_this.state.consent != true) {
                _this.setState({
                    errorMessage: _this.nameContent.error.legalDisclaimer,
                });
                window.scroll({
                    top: 0,
                    behavior: "smooth",
                });
            }
            else {
                _this.setState({ showSpinner: true });
                var files = [];
                for (var file in _this.state.files) {
                    files.push(_this.state.files[file]);
                }
                formData["files"] = files;
                ajax_util_1.default.post$(_this.props.dispatch, _this.props._csrf, "" + ROUTES.API.NAME.MAJOR_LEGAL_UPDATE, formData, { component: { name: VIEWS.UPDATE_NAME_SUCCESS } })
                    .then(function (nameInfo) {
                    page.redirect(constants_1.default.BASE_URI + "/flow" + constants_1.default.ROUTES.NAME.UPDATE_SUCCESS);
                })
                    .catch(function (error) {
                    var errorStatusCode = commonweb_utils_1.objectUtils.safeGet(error, "error.statusCode") || 500;
                    if (errorStatusCode >= 400 && errorStatusCode < 500) {
                        _this.setState({
                            errorMessage: _this.nameContent.edit.nameError,
                        });
                        window.scroll({
                            top: 0,
                            behavior: "smooth",
                        });
                    }
                    else {
                        _this.setState({
                            errorMessage: _this.props.content.common
                                .genericServerError,
                        });
                    }
                    _this.setState({ showSpinner: false });
                    return;
                });
            }
        };
        _this.nameContent = _this.props.content.name;
        _this.state = {
            consent: false,
            files: [],
            form: {},
            formIsValid: false,
            errorMessage: "",
            showSpinner: false,
        };
        _this.inputReference = React.createRef();
        return _this;
    }
    UpdateNameLegalChange.prototype.render = function () {
        var _this = this;
        var showSpinner = this.props.ui.showSpinner;
        var nameFpti = this.props.nameFpti;
        var addressProofKeys = [], legalProofKeys = [], isIdProofNeeded = false, isAddressProofNeeded = false, isLegalProofNeeded = false, fileCount = 0, mailingEnabled = true, useWebsiteOnMobileSuggestionEnabled = true, fileFormatKeyDefault = true;
        var legalChangeConfigs = this.props.legalChangeConfigs;
        addressProofKeys = commonweb_utils_1.objectUtils.safeGet(legalChangeConfigs, "addressProofKeys");
        legalProofKeys = commonweb_utils_1.objectUtils.safeGet(legalChangeConfigs, "legalProofKeys");
        isIdProofNeeded = commonweb_utils_1.objectUtils.safeGet(legalChangeConfigs, "isIdProofNeeded");
        isAddressProofNeeded = commonweb_utils_1.objectUtils.safeGet(legalChangeConfigs, "isAddressProofNeeded");
        isLegalProofNeeded = commonweb_utils_1.objectUtils.safeGet(legalChangeConfigs, "isLegalProofNeeded");
        fileCount = commonweb_utils_1.objectUtils.safeGet(legalChangeConfigs, "fileCount");
        mailingEnabled = commonweb_utils_1.objectUtils.safeGet(legalChangeConfigs, "mailingEnabled");
        useWebsiteOnMobileSuggestionEnabled = commonweb_utils_1.objectUtils.safeGet(legalChangeConfigs, "useWebsiteOnMobileSuggestionEnabled");
        fileFormatKeyDefault = commonweb_utils_1.objectUtils.safeGet(legalChangeConfigs, "fileFormatKeyDefault");
        var form = (React.createElement("form", { onSubmit: this.submitHandler },
            React.createElement(pp_react_1.Text, { size: "xl3", className: "name-header" }, this.nameContent.header.legalNameChange.title),
            this.state.errorMessage ? (React.createElement(pp_react_1.Alert, { type: "error", className: "alignLeft nameAlert" }, this.state.errorMessage)) : null,
            React.createElement(pp_react_1.Text, { size: "md", medium: true, className: "name-sub-header" }, this.nameContent.upload.text),
            React.createElement("ol", { className: "name-content" },
                isIdProofNeeded ? (React.createElement("li", null,
                    React.createElement(pp_react_1.Text, { size: "md" }, this.nameContent.idProof.text))) : null,
                isIdProofNeeded && isAddressProofNeeded ? (React.createElement(pp_react_1.Text, { size: "md", medium: true, className: "name-sub-header name-connector" }, this.nameContent.connector.and)) : null,
                isAddressProofNeeded ? (React.createElement("li", null,
                    React.createElement(pp_react_1.Text, { size: "md" }, this.nameContent.addressProof.title),
                    React.createElement("ul", { className: "nameUnorderedListDisc" }, addressProofKeys.map(function (address, index) { return (React.createElement("li", null,
                        React.createElement(pp_react_1.Text, { size: "md" }, commonweb_utils_1.objectUtils.safeGet(_this.nameContent, address)))); })))) : null,
                isIdProofNeeded && isLegalProofNeeded ? (React.createElement(pp_react_1.Text, { size: "md", medium: true, className: "name-sub-header name-connector" }, this.nameContent.connector.and)) : null,
                isLegalProofNeeded ? (React.createElement("li", null,
                    React.createElement(pp_react_1.Text, { size: "md" }, this.nameContent.legalProof.title),
                    React.createElement("ul", { className: "nameUnorderedListDisc" }, legalProofKeys.map(function (proof) { return (React.createElement("li", null,
                        React.createElement(pp_react_1.Text, { size: "md" }, commonweb_utils_1.objectUtils.safeGet(_this.nameContent, proof)))); })))) : null),
            React.createElement("input", { type: "file", name: nameFpti.upload, id: "files", className: "fileUploader", title: "", ref: this.inputReference, onChange: this.uploadHandler }),
            this.state.files.length == fileCount ? null : (React.createElement(pp_react_1.Button, { type: "button", className: "file-button", name: nameFpti.upload, disabled: this.state.showSpinner, onClick: this.uploadAction },
                React.createElement(pp_react_1.Text, { size: "md" }, this.nameContent.button.chooseFile))),
            this.state.files.length < fileCount && fileFormatKeyDefault ? (React.createElement(pp_react_1.Text, { size: "sm", className: "fileRequirements" }, this.nameContent.fileRequirements.default)) : null,
            useWebsiteOnMobileSuggestionEnabled ? (React.createElement(pp_react_1.Text, { size: "md", className: "name-content" }, this.nameContent.useWebsiteOnMobileSuggestion.text)) : null,
            mailingEnabled ? (React.createElement(pp_react_1.Text, { size: "md", className: "name-content" }, this.props.nameDocumentMailLinkComponent)) : null,
            React.createElement("ul", { className: "uploader-fileContainer name-content" }, this.state.files.map(function (file, key) { return (React.createElement("li", { key: ++key, className: "uploader-fileItem clearfix" },
                React.createElement(pp_react_1.Text, { className: "uploader-fileName" }, file.name),
                React.createElement(pp_react_1.Text, { className: "uploader-fileSize" }, file.size),
                React.createElement(pp_react_1.Text, { className: "uploader-removeFile" },
                    React.createElement(pp_react_1.Icon, { name: "clear", size: "sm", "data-name": nameFpti.removeFile, onClick: function (e) { return _this.removeFile(key, e); } }),
                    React.createElement("span", { className: "accessAid" })))); })),
            this.state.files.length == fileCount ? (
            // @ts-ignore
            React.createElement(pp_react_1.Checkbox, { name: nameFpti.consent, className: "name-text-input", disabled: this.state.showSpinner, label: this.nameContent.legalDisclaimer, id: "consent", onChange: function (event) { return _this.inputChangedHandler(event); } })) : null,
            this.state.files.length == fileCount ? (React.createElement(pp_react_1.Button, { type: "submit", className: "nameSave", name: nameFpti.submit }, this.state.showSpinner ? (React.createElement(pp_react_1.LoadingSpinner, { className: "loading-spinner", screenReaderText: "loading", inverse: true })) : (React.createElement(pp_react_1.Text, { size: "md", medium: true }, this.nameContent.button.submit)))) : null));
        return (React.createElement("div", null, this.state.showSpinner && showSpinner ? (React.createElement("div", { className: "panelSpinner" })) : (form)));
    };
    return UpdateNameLegalChange;
}(React.Component));
exports.UpdateNameLegalChange = UpdateNameLegalChange;
var File = /** @class */ (function () {
    function File(name, value, size) {
        this.name = name;
        this.value = value;
        this.size = size;
    }
    return File;
}());
var mapStateToProps = function (_a) {
    var _csrf = _a._csrf, ui = _a.ui, content = _a.content, links = _a.links, route = _a.route, account = _a.account, fpti = _a.fpti;
    var name = commonweb_utils_1.objectUtils.safeGet(account, "name") || {}, legalChangeConfigs = commonweb_utils_1.objectUtils.safeGet(account, "name.nameContentConfigs.legal") || {};
    var nameFpti = fpti.nameChange;
    var nameContent = content.name;
    var mailFilesUrl = links.mailFilesUrl.linkUrl;
    var mailLinkComponent = (React.createElement(pp_react_1.Link, { "data-name": nameFpti.mailFiles, key: nameContent.mailLink, href: mailFilesUrl }, nameContent.mailLink)), nameDocumentMailLinkComponent = interpolate_component_1.InterpolateLinksWithComponent(nameContent.mail.text, [mailLinkComponent]);
    return {
        _csrf: _csrf,
        ui: ui,
        content: content,
        route: route,
        name: name,
        legalChangeConfigs: legalChangeConfigs,
        nameDocumentMailLinkComponent: nameDocumentMailLinkComponent,
        nameFpti: nameFpti,
    };
};
function mapDispatchToProps(dispatch) {
    return {
        dispatchNameChange: function (nameInfo) { return dispatch(name_1.changeName(nameInfo)); },
        dispatch: dispatch,
    };
}
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(UpdateNameLegalChange);
